"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productPaths = exports.CHINA_URL = exports.STORE = void 0;
exports.STORE = "/store";
exports.CHINA_URL = "https://ryersonchina.com";
exports.productPaths = [{
  url: "/tool-steel",
  label: "Tool Steel",
  contentful_id: "63mfJz6pdSEhcIoe1p5ik8"
}, {
  url: "/aluminum",
  label: "Aluminum",
  contentful_id: "4usnmGY6fQr7NsxbNaMRko"
}, {
  url: "/stainless",
  label: "Stainless Steel",
  contentful_id: "4Ej8KGQom2Pvkrq28Kj79u"
}, {
  url: "/steel",
  label: "Steel",
  contentful_id: "4CITuK6xP6EqWhqit21gWK"
}, {
  url: "/alloy",
  label: "Alloy",
  contentful_id: "622Ta1OjuYU7t75wFOjwFu"
}, {
  url: "/nickel",
  label: "Nickel",
  contentful_id: "4m6tLgN4g8lky0BJeENhLt"
}, {
  url: "/brass-copper-bronze",
  label: "Brass, Copper, & Bronze",
  contentful_id: "1DnsAOKuew5PYeAcd8rkoD"
}];